import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';

import IconButton from 'components/common/IconButton';
import Menu, { MenuItem } from 'components/common/Menu';
import IconMoreVert from 'components/icons/IconMoreVert';
import DiagnosisCreateEditDialog from 'components/settings/DiagnosisCreateEditDialog';
import Link from 'components/common/Link';

import splitLongWords from 'utils/splitLongWords';
import pxToRem from 'styles/pxToRem';

import dateFormat from 'config/dateFormat';

const styles = theme => ({
  iconMoreVert: {
    width: 24,
    height: 24,
  },
  buttonCell: {
    textAlign: 'right',
    padding: '0 10px 0 0',
    '&:last-child': {
      padding: '0 10px 0 0',
    },
  },
  cellExpire: {
    whiteSpace: 'nowrap',
  },
  cellDescription: {
    width: '43%',
  },
  typographyExpire: {
    fontSize: pxToRem(13),
    backgroundColor: theme.palette.validation[300],
  },
});

class DiagnosesTableRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      editDialogOpen: false,
    };

    this.onMenuButtonClick = this.onMenuButtonClick.bind(this);
    this.onMenuClose = this.onMenuClose.bind(this);
    this.onEditMenuItemClick = this.onEditMenuItemClick.bind(this);
    this.onEditDialogClose = this.onEditDialogClose.bind(this);
  }

  onMenuButtonClick(event) {
    this.setState({
      anchorEl: event.currentTarget,
    });
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onEditMenuItemClick() {
    this.setState({
      anchorEl: null,
      editDialogOpen: true,
    });
  }

  onEditDialogClose() {
    this.setState({ editDialogOpen: false });
  }

  render() {
    const { account, classes } = this.props;
    const { anchorEl, editDialogOpen } = this.state;
    const open = Boolean(anchorEl);

    return (
      <TableRow>
        <TableCell>
          <Link
            breakWord
            onClick={this.onEditMenuItemClick}
            disabled={account.Roles.filter(item =>
              item.Name === 'Master Administrator' || item.Name === 'Administrator' || item.Name === 'Manager').length === 0}
          >
            {this.props['DX Code']}
          </Link>
        </TableCell>
        <TableCell className={classes.cellExpire}>
          {(this.props['Expire At'] && moment(this.props['Expire At'], dateFormat).isSameOrBefore(moment())) ? (
            <Typography className={classes.typographyExpire}>
              {this.props['Expire At']}
            </Typography>
          ) : this.props['Expire At']}
        </TableCell>
        <TableCell className={classes.cellDescription}>
          {this.props['Long Description']
            && splitLongWords(this.props['Long Description'])}
        </TableCell>
        <TableCell className={classes.cellDescription}>
          {this.props['Short Description']
            && splitLongWords(this.props['Short Description'])}
        </TableCell>
        <TableCell className={classes.buttonCell}>
          <IconButton
            aria-label="More"
            aria-owns={open ? `${this.props.ID}-diagnosis-menu` : null}
            aria-haspopup="true"
            onClick={this.onMenuButtonClick}
            tooltipContent="Open Menu"
          >
            <IconMoreVert className={classes.iconMoreVert} />
          </IconButton>
          <Menu
            id={`${this.props.ID}-diagnosis-menu`}
            anchorEl={anchorEl}
            open={open}
            onClose={this.onMenuClose}
            list
            maxHeight={130}
          >
            <MenuItem
              onClick={this.onEditMenuItemClick}
              disabled={account.Roles.filter(item =>
                item.Name === 'Master Administrator' || item.Name === 'Administrator' || item.Name === 'Manager').length === 0}
            >
              Edit
            </MenuItem>
          </Menu>
        </TableCell>
        <DiagnosisCreateEditDialog
          form={`diagnosisEdit-${this.props.ID}`}
          open={editDialogOpen}
          ID={this.props.ID}
          initialValues={{
            'DX Code': this.props['DX Code'],
            'Expire At': this.props['Expire At'],
            'Long Description': this.props['Long Description'],
            'Medium Description': this.props['Medium Description'],
            'Short Description': this.props['Short Description'],
          }}
          onClose={this.onEditDialogClose}
          onSubmitSuccess={this.onEditDialogClose}
        />
      </TableRow>
    );
  }
}

DiagnosesTableRow.propTypes = {
  ID: PropTypes.number.isRequired,
  'DX Code': PropTypes.string.isRequired,
  'Long Description': PropTypes.string,
  'Medium Description': PropTypes.string,
  'Short Description': PropTypes.string,
  account: PropTypes.shape({
    Roles: PropTypes.arrayOf(PropTypes.shape({
      Name: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    iconMoreVert: PropTypes.string.isRequired,
    buttonCell: PropTypes.string.isRequired,
  }).isRequired,
};

DiagnosesTableRow.defaultProps = {
  'Long Description': null,
  'Medium Description': null,
  'Short Description': null,
};

const mapStateToProps = store => ({
  account: store.account,
});

export default connect(mapStateToProps)(withStyles(styles)(DiagnosesTableRow));



// WEBPACK FOOTER //
// ./src/components/settings/DiagnosesTable/DiagnosesTableRow.js